import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { PpcEyebrow } from '@design-system/eyebrow/eyebrow';
import { PpcHeading } from '@design-system/heading/heading';

@Component({
  selector: 'app-about',
  imports: [TranslatePipe, PpcEyebrow, PpcHeading],
  templateUrl: './about.html',
  styleUrl: './about.css',
})
export class AboutComponent {
  private readonly translate = inject(TranslateService);

  private readonly HEAD_PARAGRAPH_COUNT = 2;

  protected readonly portrait = '/assets/img/founders.jpg';

  protected readonly paragraphs = toSignal(this.translate.stream('about.paragraphs'), {
    initialValue: [] as string[],
  });

  protected readonly palmares = toSignal(this.translate.stream('about.palmares'), {
    initialValue: [] as { num: string; label: string }[],
  });

  protected readonly head = computed(() => this.paragraphs().slice(0, this.HEAD_PARAGRAPH_COUNT));
  protected readonly tail = computed(() => this.paragraphs().slice(this.HEAD_PARAGRAPH_COUNT));
}
